var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.chartData)?_c('line-chart',{attrs:{"chart-data":_vm.chartData,"baseHexColor":_vm.baseHexColor,"height":300}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }